// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { Dealer_Viewable_Driver_Info } from '@gql/base-types';

import { css } from '@emotion/css';
import { Theme, useTheme, Avatar, Tooltip, Typography } from '@mui/material';
import { BiSolidUser } from 'react-icons/bi';

// TYPES ---------------------------------------------------------------- //

interface MoveDetailsDriverImageProps {
  driver?: Dealer_Viewable_Driver_Info;
}

// COMPONENT ---------------------------------------------------------------- //

const MoveDetailsDriverImage = ({ driver }: MoveDetailsDriverImageProps) => {
  const theme = useTheme();
  const cls = useStyles(theme);

  return (
    <div className={cls.image}>
      <Typography
        sx={{
          fontWeight: 600,
          color: theme?.palette?.text?.disabled,
        }}
      >
        DRIVER
      </Typography>

      <div className={cls.imageBox}>
        <Avatar
          alt={driver?.display_name || `HopDriver`}
          src={driver?.avatar_url || ``}
          sx={{
            width: 96,
            height: 96,
            fontSize: 36,
            backgroundColor: theme?.palette?.utility?.lighter,
          }}
        >
          <BiSolidUser size={56} />
        </Avatar>

        <Tooltip title={driver?.display_name || `HopDriver`} placement='top'>
          <div className={cls.imageBoxShadow} />
        </Tooltip>
      </div>
    </div>
  );
};

// STYLES ---------------------------------------------------------------- //

const useStyles = (theme?: Theme) => ({
  image: css`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    margin-top: 6px;
    ${theme?.breakpoints?.down(`sm`)} {
      display: none;
    }
  `,
  imageBox: css`
    position: relative;
  `,
  imageBoxShadow: css`
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 50%;
    box-shadow: 0px 0px 12px 2px #00000030 inset;
    cursor: pointer;
  `,
});

// EXPORT ---------------------------------------------------------------- //

export default MoveDetailsDriverImage;
